// For adding rel="nofollow" to <a></a> when target="_blank"
export default function nofollow(target) {
  if (target === '_blank') {
    return `nofollow`
  }
  return null
}



// WEBPACK FOOTER //
// ./includes/yoco-website-cms-gatsby/src/utils/helpers/nofollow.js